import { Component, ElementRef, QueryList, ViewChildren } from '@angular/core';
import { AlertController, NavParams, ViewController } from 'ionic-angular';

import { GestaoPcaService } from '../../../../providers/gestao-pca-service';
import { PessoalService } from '../../../../providers/pessoal-service';
// import 'highcharts/adapters/standalone-framework.src';

const Highcharts = require('highcharts');

declare var require: any;

@Component({
  selector: 'page-modal-pv-pessoal',
  templateUrl: 'modal-pv-pessoal.html',
  providers: [
    PessoalService
  ]
})
export class ModalPreVisualizarPessoalPage {
  @ViewChildren('chart') public charts: QueryList<ElementRef>;
  // @ViewChildren('chart2') public charts2: QueryList<ElementRef>;

  private chartEl: ElementRef;
  private _chart: any;
  private chartEl2: ElementRef;
  private _chart2: any;
  titulo: any;
  isJurisdicionado: any;
  listaDados: any;
  listaDadosVinculos: any;
  dataGeracao: any;
  loading: boolean = true;
  shownGroup: any = [];
  listaDadosElementoDespesa: any = [];
  listaDadosElementoDespesaAux: any = [];

  constructor(private viewCtrl: ViewController,
    public navParams: NavParams,
    public pessoalService: PessoalService,
    public alertCtrl: AlertController,
    public gestaoPcaService: GestaoPcaService) {

    this.dataGeracao = new Date();

    this.listarDados();
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  listarDados() {
    this.pessoalService.obterPessoalCertificado().subscribe(
      data => {
        this.listaDados = data;

        if (data != null && data.visaoGerencialWrapper.vinculos != null) {

          this.listaDadosVinculos = data.visaoGerencialWrapper.vinculos.map((elem) => ([elem.dsGrupoCargo, elem.qtdGrupoCargo]));

          this.carregarGrafico();
        }

        if (data != null && data.visaoGerencialElemento31Wrapper.modalidades != null) {

          this.listaDadosElementoDespesaAux = data.visaoGerencialElemento31Wrapper.modalidades.filter(desp => desp.descricao === "NÃO SE APLICA").map((elem) => ([elem.descricao, elem.elementoDespesas.map((desp) => ([desp.nome, desp.valor]))]));

          for (let i = 0; i < this.listaDadosElementoDespesaAux.length; i++) {

            let data = [];

            this.listaDadosElementoDespesaAux[i][1].forEach(element => {
              this.listaDadosElementoDespesa.push({
                name: element[0],
                y: element[1]
              });
            });

            this.carregarGraficoElemento31();
          }
        }

        this.loading = false;
      }, error => {
        console.log("erro: " + error);
        this.loading = false;
      }
    );
  }

  //  #region Métodos do Accordion
  toggleGroup(group) {
    if (this.isGroupShown(group)) {
      let index = this.shownGroup.indexOf(group);
      this.shownGroup.splice(index, 1);
    } else {
      this.shownGroup.push(group);
    }

    if (group == 30) {
      this.carregarGrafico();
    }
  }

  isGroupShown(group) {
    return this.shownGroup.indexOf(group) != -1;
  };

  formatarZeroEsquerda(valor) {
    return valor.replace(/^0+(?!\.|$)/, '');
  }

  carregarGrafico() {

    let opts: any = {
      title: { text: 'Visão Gerencial do Quadro de Pessoal' },
      // subtitle: {
      //     text: 'Clique nas modalidades para ter uma visão por elemento de despesa'
      // },
      credits: {
        enabled: false
      },
      yAxis: {
        min: 0,
        title: {
          text: 'Quantidade'
        }
      },
      xAxis: {
        type: 'category',
        labels: {
          style: {
            fontSize: '9px',
            fontFamily: 'Verdana, sans-serif'
          }
        }
      },
      tooltip: {
        formatter: function () {
          var seriesData = this.series.data;

          var total = 0;
          for (var i = 0; i < seriesData.length; i++) {
            total += seriesData[i].y
          }

          return '<span style="font-size:13px">' + this.series.data[this.x].name + '</span><br><br/>' +
            '<b>' + (100 * this.y / total).toFixed(2) + '%</b> do total<br/><br/>' +
            '<span style="color:' + this.color + '">Valor (R$)</span>: <b>' + Highcharts.numberFormat(this.y, 2, ',', '.') + '</b><br/>' +
            '<span style="color:' + this.color + '">Total (R$)</span>: <b>' + Highcharts.numberFormat(total, 2, ',', '.') + '</b><br/>';
        }
      },
      legend: {
        enabled: false
      },
      plotOptions: {
        series: {
          // cursor: 'pointer',
          dataLabels: {
            enabled: true,
            formatter: function () {
              var seriesData = this.series.data;

              var total = 0;
              for (var i = 0; i < seriesData.length; i++) {
                total += seriesData[i].y
              }

              return (100 * this.y / total).toFixed(2) + "%";
            }
          }
        }
      },
      series: [{
        name: 'Vínculos',
        colorByPoint: true,
        data: this.listaDadosVinculos
      }],
      // drilldown: {
      //     name: "Elementos de Despesa",
      //     colorByPoint: true,
      //     series: this.listaDadosElementoDespesaData
      // },
      exporting: {
        enabled: true,
        sourceWidth: 1920
      }
    };

    if (this.chartEl && this.chartEl.nativeElement) {
      opts.chart = {
        type: 'column',
        plotBackgroundColor: null,
        plotBorderWidth: 0,
        plotShadow: false,
        backgroundColor: 'transparent',
        renderTo: 'chart1'
      };

      this._chart = new Highcharts.Chart(opts);
    }

  }

  carregarGraficoElemento31() {

    let opts: any = {
      title: { text: 'Visão Gerencial dos Gastos com Pessoal' },
      // subtitle: {
      //     text: 'Clique nas modalidades para ter uma visão por elemento de despesa'
      // },
      credits: {
        enabled: false
      },
      yAxis: {
        min: 0,
        title: {
          text: 'Gastos com Pessoal (R$)'
        }
      },
      xAxis: {
        type: 'category',
        labels: {
          style: {
            fontSize: '9px',
            fontFamily: 'Verdana, sans-serif'
          }
        }
      },
      tooltip: {
        formatter: function () {
          var seriesData = this.series.data;

          var total = 0;
          for (var i = 0; i < seriesData.length; i++) {
            total += seriesData[i].y
          }

          return '<span style="font-size:13px">' + this.series.data[this.x].name + '</span><br><br/>' +
            '<b>' + (100 * this.y / total).toFixed(2) + '%</b> do total<br/><br/>' +
            '<span style="color:' + this.color + '">R$</span>.: <b>' + Highcharts.numberFormat(this.y, 2, ',', '.') + '</b><br/>' +
            '<span style="color:' + this.color + '">Total</span>: <b>' + Highcharts.numberFormat(total, 2, ',', '.') + '</b><br/>';
        }
      },
      legend: {
        enabled: false
      },
      plotOptions: {
        series: {
          // cursor: 'pointer',
          dataLabels: {
            enabled: true,
            formatter: function () {
              var seriesData = this.series.data;

              var total = 0;
              for (var i = 0; i < seriesData.length; i++) {
                total += seriesData[i].y
              }

              return (100 * this.y / total).toFixed(2) + "%";
            }
          }
        }
      },
      series: [{
        name: 'Gastos',
        colorByPoint: true,
        data: this.listaDadosElementoDespesa
      }],
      exporting: {
        enabled: true,
        sourceWidth: 1920
      }
    };

    if (this.chartEl2 && this.chartEl2.nativeElement) {
      opts.chart = {
        type: 'column',
        plotBackgroundColor: null,
        plotBorderWidth: 0,
        plotShadow: false,
        backgroundColor: 'transparent',
        renderTo: 'chart2'
      };

      this._chart2 = new Highcharts.Chart(opts);
    }

  }

  public ngAfterViewInit(): void {
    this.charts.changes.subscribe((comps: QueryList<ElementRef>) => {

      this.chartEl = comps.last;
      this.carregarGrafico();

      this.chartEl2 = comps.first;
      this.carregarGraficoElemento31();
    });
  }

  formatarPorcentagem(valor) {
    let val = "0%";

    if (valor) {
      val = valor.toString().replace('.', ',') + "%";
    }

    return val;
  }

  cnpj_mask(v) {
    v = v.replace(/\D/g, ''); //Remove tudo o que não é dígito
    v = v.replace(/(\d{2})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
    v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
    //de novo (para o segundo bloco de números)
    v = v.replace(/(\d{3})(\d)/, '$1/$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
    v = v.replace(/(\d{4})(\d{1,2})$/, '$1-$2'); //Coloca um hífen entre o terceiro e o quarto dígitos
    return v;
  }

  formatarValorNumerico(valor) {
    let valorFormatado = new Intl.NumberFormat('pt-BR',
      {
        style: 'currency',
        currency: 'BRL'
      }).format(valor);

    return valorFormatado.substr(2, valorFormatado.length).replace('$', '-');
  }

  somarInicioExercicio(item) {
    let val = 0;

    item[1].forEach(element => {
      val += +element.demonstrativo.inicioExercicio;
    });

    return val;
  }

  somarCriadosExercicio(item) {
    let val = 0;

    item[1].forEach(element => {
      val += +element.demonstrativo.criadosExercicio;
    });

    return val;
  }

  somarExtintosExercicio(item) {
    let val = 0;

    item[1].forEach(element => {
      val += +element.demonstrativo.extintosExercicio;
    });

    return val;
  }

  somarFinalExercicio(item) {
    let val = 0;

    item[1].forEach(element => {
      val += +element.demonstrativo.finalExercicio;
    });

    return val;
  }

  somarOcupadosInicioExercicio(item) {
    let val = 0;

    item[1].forEach(element => {
      val += +element.demonstrativo.ocupadosInicioExercicio;
    });

    return val;
  }

  somarNomeadosExercicio(item) {
    let val = 0;

    item[1].forEach(element => {
      val += +element.demonstrativo.nomeadosExercicio;
    });

    return val;
  }

  somarCargosExoneradosExercicio(item) {
    let val = 0;

    item[1].forEach(element => {
      val += +element.demonstrativo.cargosExoneradosExercicio;
    });

    return val;
  }

  somarOcupadosfinalExercicio(item) {
    let val = 0;

    item[1].forEach(element => {
      val += +element.demonstrativo.ocupadosfinalExercicio;
    });

    return val;
  }

  somarCargosVagosFinalExercicio(item) {
    let val = 0;

    item[1].forEach(element => {
      val += +element.demonstrativo.cargosVagosFinalExercicio;
    });

    return val;
  }

  calcularDiferenca(item) {
    return item.qtdCargosDem - item.qtdCargosQuadro;
  }


  cpf_mask(v) {
    v = v.replace(/\D/g, ''); //Remove tudo o que não é dígito
    v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
    v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
    //de novo (para o segundo bloco de números)
    v = v.replace(/(\d{3})(\d{1,2})$/, '$1-$2'); //Coloca um hífen entre o terceiro e o quarto dígitos
    return v;
  }
}



// WEBPACK FOOTER //
// ./src/pages/modais/modal-pre-visualizacao/pessoal/modal-pv-pessoal.ts